import React from "react";

export const Bs = () => <>&nbsp;</>